module.exports = __webpack_public_path__ + "img/zhongguo.20798bfa.png";